import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useQuery } from "react-query";

import { ReferentialItemDto } from "../../api";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface ISectorTypeSelectProps extends IFGSelectInputProps<any> {
  name: string;
  label?: string;
}

export const SectorTypeSelect: React.FunctionComponent<
  ISectorTypeSelectProps
> = ({ name, label, ...fgSelectInputProps }) => {
  const { t, apis } = useCommonHooks();
  const { data, isFetching } = useQuery(
    [`ref-sector-types`],
    async () => {
      return apis.referential.getSectorTypes();
    },
    { staleTime: Infinity }
  );

  return (
    <FGSelectInput
      label={label || t(ETLCodes.SectorType)}
      name={name}
      items={data}
      loading={isFetching}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
